import {
  createRoutesResourceGuard,
  deleteRoutesResourceGuard,
  editRoutesResourceGuard,
  routesCollectionGuard,
  routesResourceGuard,
} from './_api/sortingMachines';

export const resourceSortingMachinesRoutes = routesResourceGuard;
export const deleteSortingMachinesRoutes = deleteRoutesResourceGuard;
export const createSortingMachinesRoutes = createRoutesResourceGuard;
export const collectionSortingMachinesRoutes = routesCollectionGuard;
export const editSortingMachinesRoutes = editRoutesResourceGuard;

export const routeGuard = routesCollectionGuard;
